import React, { useEffect, useState } from "react";
import PaidOut from "./PaidOut";
import StakingCard from "./StakingCard";
const Layout = () => {
	const [mobile, setMobile] = useState(true);

	const handleCheckDevice = () => {
		if (window.innerWidth >= 992) {
			setMobile(false);
		} else {
			setMobile(true);
		}
		return;
	};

	useEffect(() => {
		handleCheckDevice();
		window.addEventListener("resize", handleCheckDevice);
	}, []);

	return (
		<article className="full-layout">
			<div className="container">
				<div className="row g-3 g-xl-4">
					<div className="col-lg-6">
						<div className="row g-3 g-xl-4">
							{mobile && (
								<div className="col-md-12">
									<StakingCard />
								</div>
							)}
							<div className="col-md-12">
								<div className="destribute-card bg--base">
									<h5>AUTO - DISTRIBUTE </h5>
									<a href="/#" className="balance-button bg-white">
										<span className="text--base">5,000.45 VFT</span>
									</a>
								</div>
							</div>
							<div className="col-md-12">
								<div className="card cmn--card">
									<div className="card-header">
										<h5 className="card-title">Statistics</h5>
										<a className="card-btn" href="/#">
											See More
										</a>
									</div>
									<div className="card-body p-0">
										<ul className="statistics-list">
											<li>
												<span>Total Staked</span>
												<span>348,938.99</span>
											</li>
											<li>
												<span>Total Rewards Claimed (USDT)</span>
												<span>5,693.00</span>
											</li>
											<li>
												<span>Pool Max participants </span>
												<span>Unlimited</span>
											</li>
											<li>
												<span>Staking / Unstake Fee</span>
												<span>0.9 %</span>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div className="col-md-12">
								<div className="card cmn--card">
									<div className="card-header">
										<h5 className="card-title">Paid Out</h5>
									</div>
									<div className="card-body p-0">
										<div className="paid-out-balance-area">
											<ul className="paid-out-balance">
												<li> = 5,693.00 USDT</li>
												<li> = 2,741.13 VFT (VFT Rebase)</li>
											</ul>
											<div className="currency-symbol">
												<span className="symbol-name">
													<span
														className="left-symbol"
														style={{
															background: `linear-gradient(218.33deg, #2ED3ED -15.34%, #5C31F5 126.42%)`,
														}}
													></span>
													$VFT
												</span>
												<span className="symbol-name">
													<span
														className="left-symbol"
														style={{
															background: `linear-gradient(152.25deg, #EE6D50 33.75%, #A62D12 81.68%)`,
														}}
													></span>
													$USDT
												</span>
											</div>
											<PaidOut vft="5693.00" usdt="2741.13" />
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-12">
								<div className="card cmn--card">
									<div className="card-header">
										<h5 className="card-title">Pool Value</h5>
										<span className="d-flex align-items-center">
											Vs Last Week
											<strong className="text-white ms-2 me-1">
												3.2%
											</strong>
											<span className="indicator ms-2"></span>
										</span>
									</div>
									<div className="card-body p-0">
										<div className="paid-out-balance-area">
											<ul className="paid-out-balance">
												<li> = 318,074,741.13 $SUT</li>
												<li> = 318,074,741.13 $SUT</li>
											</ul>
											<div className="currency-symbol d-flex flex-wrap justify-content-center">
												<span className="symbol-name me-xl-5">
													<span
														className="left-symbol"
														style={{
															background: `linear-gradient(218.33deg, #2ED3ED -15.34%, #5C31F5 126.42%)`,
														}}
													></span>
													$VFT
												</span>
												<span className="symbol-name ms-xl-4">
													<span
														className="left-symbol"
														style={{
															background: `linear-gradient(152.25deg, #EE6D50 33.75%, #A62D12 81.68%)`,
														}}
													></span>
													$USDT
												</span>
											</div>
											<PaidOut vft="5693.00" usdt="2741.13" />
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="col-lg-6">
						<div className="row g-4">
							{!mobile && (
								<div className="col-md-12">
									<StakingCard />
								</div>
							)}
							<div className="col-md-12">
								<div className="card cmn--card">
									<div className="card-header">
										<h5 className="card-title">My Pool Position</h5>
										<span className="d-flex align-items-center">
											Vs Last Week
											<strong className="text-white ms-2 me-1">
												3.2%
											</strong>
											<span className="indicator ms-2"></span>
										</span>
									</div>
									<div className="card-body pool--position">
										<div className="text-center">
											<h3 className="title text--base"> =20%</h3>
										</div>
										<div className="currency-symbol d-flex flex-wrap justify-content-center mt-3">
											<span className="symbol-name me-xl-5">
												<span
													className="left-symbol"
													style={{
														background: `linear-gradient(152.25deg, #EE6D50 33.75%, #A62D12 81.68%)`,
													}}
												></span>
												My position
											</span>
											<span className="symbol-name ms-xl-4">
												<span
													className="left-symbol"
													style={{
														background: `linear-gradient(261.58deg, #B5EE2F -1.57%, #22E1A7 106.07%)`,
													}}
												></span>
												Total Position
											</span>
										</div>
										<div className="progress-card">
											<div
												className="progress-left"
												style={{
													background: `linear-gradient(152.25deg, #EE6D50 33.75%, #A62D12 81.68%)`,
													width: `30%`,
												}}
											></div>
											<div
												className="progress-right"
												style={{
													background: `linear-gradient(261.58deg, #B5EE2F -1.57%, #22E1A7 106.07%)`,
													width: `70%`,
												}}
											></div>
										</div>
										<div className="stake-button-container">
											<a href="/#" className="cmn--btn">
												BUY VFT
											</a>
											<a
												href="/#"
												className="cmn--btn btn-secondary"
											>
												STAKE VFT
											</a>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="col-lg-4">
						<div className="card cmn--card">
							<div className="card-body p-0">
								<ul className="tier--list">
									<li>
										<a href="/#" className="tier--list-item">
											<span>- Tier 1</span>
											<span>(20% Off)</span>
										</a>
									</li>
									<li>
										<a href="/#" className="tier--list-item active">
											<span>- Tier 2</span>
											<span>(50% Off)</span>
										</a>
									</li>
									<li>
										<a href="/#" className="tier--list-item">
											<span>- Tier 3</span>
											<span>(70% Off)</span>
										</a>
									</li>
									<li>
										<a href="/#" className="tier--list-item">
											<span>- Tier 4</span>
											<span>(100% Off)</span>
										</a>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<div className="col-lg-8">
						<div className="card cmn--card">
							<div className="card-body">
								<div className="card-staking-tier-progress-area">
									<div className="header">
										<h4 className="title">VFT Staking Tier</h4>
										<p>
											Save up to 100% fee on this pool by staking on
											VFT staking Dapp.
										</p>
									</div>
									<span>My Stake VFT - $20,000</span>
									<h5 className="raise-amount">
										<span>0$</span>
										<span>$100,00</span>
									</h5>
									<div className="progress-2">
										<div
											className="progress-2-inner"
											style={{ width: `50%` }}
										></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</article>
	);
};

export default Layout;
